var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-manual",class:{ mobile: _vm.isMobile }},[(_vm.isSelectMode)?_c('UserManualSelect'):_c('vue-pdf-app',{attrs:{"pageScale":"page-fit","pdf":_vm.pdf.src,"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }